// src/redux/reducers/cache.js
import {
  CACHE_BEGIN,
  CACHE_CLEAR,
  CACHE_FAILURE,
  CACHE_SUCCESS,
  CACHE_CLEAR_PREFIX,
} from "@redux/actions/cachedApiActions";

const initial = { byKey: {} };

export default function cachedApiReducer(state = initial, action) {
  switch (action.type) {
    case CACHE_BEGIN: {
      const { key, requestId, ttlMs } = action.payload;
      const prev = state.byKey[key];
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [key]: {
            ...(prev || {}),
            status: "loading",
            error: null,
            requestId,
            ttlMs: ttlMs ?? prev?.ttlMs ?? 24 * 60 * 60 * 1000, // default 24h
          },
        },
      };
    }
    case CACHE_SUCCESS: {
      const { key, requestId, data } = action.payload;
      const cur = state.byKey[key];
      if (!cur || cur.requestId !== requestId) return state; // stale response
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [key]: {
            ...cur,
            status: "succeeded",
            data,
            ts: Date.now(),
            error: null,
          },
        },
      };
    }
    case CACHE_FAILURE: {
      const { key, requestId, error } = action.payload;
      const cur = state.byKey[key];
      if (!cur || cur.requestId !== requestId) return state;
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [key]: { ...cur, status: "failed", error: String(error) },
        },
      };
    }
    case CACHE_CLEAR: {
      const next = { ...state.byKey };
      delete next[action.payload.key];
      return { ...state, byKey: next };
    }
    case CACHE_CLEAR_PREFIX: {
      const { prefix } = action.payload;
      const next = {};
      for (const k of Object.keys(state.byKey)) {
        if (!k.startsWith(prefix)) next[k] = state.byKey[k];
      }
      return { ...state, byKey: next };
    }
    default:
      return state;
  }
}

export const selectCacheEntry = (state, key, slice = "cachedApi") =>
  state?.[slice]?.byKey?.[key] || null;
export const isFresh = (entry) =>
  entry?.ts && Date.now() - entry.ts < (entry.ttlMs ?? 24 * 60 * 60 * 1000);
